__turbopack_context__.v({
  "container": "iu54tW_container",
  "container--controls-hidden": "iu54tW_container--controls-hidden",
  "container__poster": "iu54tW_container__poster",
  "container__poster--hidden": "iu54tW_container__poster--hidden",
  "container__recommendation-card-container": "iu54tW_container__recommendation-card-container",
  "container__skeleton": "iu54tW_container__skeleton",
});
